import React, { Component } from 'react';
import ComingLivestreams from './ComingLivestreams.js';

class UpcomingLivestreams extends Component {
  constructor(props) {
    super(props);

    // TODO lots of hard coded data to keep up to date
    this.state = {
      featuredLivestreams: [
        {
          "creatorAddress": "0x8db82fb66b5050d8cd996c4f0d86a10e340837aa",
          "creatorImage": "https://pbs.twimg.com/profile_images/1541108844012527616/arW6NSo0_400x400.jpg",
          "creatorName": "Devin Tracy",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmcwCa8pfmxhuCPftNdx1ydoxSfYAWTiK71k3pApFDUud9.png",
          "itemDate": "Nov.",
          "itemName": "Genesis Livestream",
          "itemRoute": "/profile/devintracy"
        },
      ]
    }
  }

  render() {
    return (
      <div>
        <div className="justify-center">
          <ComingLivestreams
            address={this.props.address}
            featuredLivestreams={this.state.featuredLivestreams}
            selectItemForSubscribe={this.props.selectItemForSubscribe}
            subscriberStatuses={this.props.subscriberStatuses}
          />
        </div>
      </div>
    );
  }
}

export default UpcomingLivestreams;
